import React from "react";
import { useField, useFormikContext } from "formik";
import DatePicker from "react-datepicker";

export const PbDatePicker = ({ ...props }) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(props);

  const formatToDateTimeString = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  return (
      <React.Fragment>
          <DatePicker
            {...field}
            {...props}
            className="form-control form-text"
            selected={(field.value && new Date(field.value)) || null}
            onChange={val => {
                const dateTimeString = formatToDateTimeString(val);
                console.log(dateTimeString);
                setFieldValue(field.name, dateTimeString);
            }}
            />
            {meta.touched && meta.error ? (
                <div className="error">{meta.error}</div>
            ) : null
    }
      </React.Fragment>
  );
};

export default PbDatePicker;
